import { render, staticRenderFns } from "./FootballPlayer.vue?vue&type=template&id=1e39e274&scoped=true&"
import script from "./FootballPlayer.vue?vue&type=script&lang=js&"
export * from "./FootballPlayer.vue?vue&type=script&lang=js&"
import style0 from "./FootballPlayer.vue?vue&type=style&index=0&id=1e39e274&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e39e274",
  null
  
)

export default component.exports